import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propShape, propStr } from '../../../../../../helpers/custom-prop-types';
import SolutionError from '../Error';
const SolutionBaseTextarea = ({ input, inputClass, meta, placeholder }) => {
    const isError = meta.touched && meta.error;
    return (_jsxs(_Fragment, { children: [_jsx("textarea", Object.assign({}, input, { className: `${inputClass} ${isError ? 'is-warning' : ''}`, placeholder: placeholder })), _jsx(SolutionError, { error: isError ? meta.error : '' })] }));
};
SolutionBaseTextarea.propTypes = {
    input: propShape().isRequired,
    inputClass: propStr(),
    meta: propShape().isRequired,
    placeholder: propStr().isRequired,
};
SolutionBaseTextarea.defaultProps = {
    inputClass: 'input-form-textarea is-large',
};
export default SolutionBaseTextarea;
